import { browserHistory } from 'react-router';

export default function(error, dispatch) {

	if (error && error.status === 401){
		browserHistory.push('/access-denied');
		return true;
	} else {
		return false;
	}

}



// WEBPACK FOOTER //
// ./src/assets/js/lib/logout.js